<ul [class.side-ul]="sideView" [class.navbar-nav]="!sideView">
  <li
    [class.btn]="!sideView"
    [class.btn-link]="!sideView"
    [class.nav-link]="!sideView"
    [class.flex-end--mobile]="!sideView"
    [class.text-start]="!sideView"
    *ngIf="!isEmployeePortal"
    routerLink="{{ baseUrl }}/{{ clientCode | async }}"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: true }">
    <img
      [class.d-inline-block]="!sideView"
      [class.me-3]="!sideView"
      [class.ms-3]="!sideView"
      src="assets/icons/home.svg" />
    <div class="menu-text" [class.d-inline-block]="!sideView">Home</div>
  </li>
  <li
    [class.btn]="!sideView"
    [class.btn-link]="!sideView"
    [class.nav-link]="!sideView"
    [class.flex-end--mobile]="!sideView"
    [class.text-start]="!sideView"
    *ngIf="authService.canRead('employee') && canEditPeople"
    routerLinkActive="active"
    routerLink="{{ baseUrl }}/{{ clientCode | async }}/people"
    [ngClass]="{ active: activeTab == 'People' }">
    <img
      [class.d-inline-block]="!sideView"
      [class.me-3]="!sideView"
      [class.ms-3]="!sideView"
      src="assets/icons/people.svg" />
    <div class="menu-text" [class.d-inline-block]="!sideView">People</div>
  </li>
  <li
    [class.btn]="!sideView"
    [class.btn-link]="!sideView"
    [class.nav-link]="!sideView"
    [class.flex-end--mobile]="!sideView"
    [class.text-start]="!sideView"
    *ngIf="payrollRoute && canDoPayroll"
    [routerLink]="payrollRoute"
    [ngClass]="{ active: activeTab == 'Payroll' }">
    <img
      [class.d-inline-block]="!sideView"
      [class.me-3]="!sideView"
      [class.ms-3]="!sideView"
      src="assets/icons/payroll.svg" />
    <div class="menu-text" [class.d-inline-block]="!sideView">Payroll</div>
  </li>
  <li
    [class.btn]="!sideView"
    [class.btn-link]="!sideView"
    [class.nav-link]="!sideView"
    [class.flex-end--mobile]="!sideView"
    [class.text-start]="!sideView"
    *ngIf="canViewReports"
    routerLinkActive="active"
    routerLink="{{ baseUrl }}/{{ clientCode | async }}/reports">
    <img
      [class.d-inline-block]="!sideView"
      [class.me-3]="!sideView"
      [class.ms-3]="!sideView"
      src="assets/icons/reports.svg" />
    <div class="menu-text" [class.d-inline-block]="!sideView">Reports</div>
  </li>
  <li
    [class.btn]="!sideView"
    [class.btn-link]="!sideView"
    [class.nav-link]="!sideView"
    [class.flex-end--mobile]="!sideView"
    [class.text-start]="!sideView"
    *ngIf="!isClientPortal && !isEmployeePortal"
    routerLinkActive="active"
    routerLink="{{ baseUrl }}/{{ clientCode | async }}/company">
    <img
      [class.d-inline-block]="!sideView"
      [class.me-3]="!sideView"
      [class.ms-3]="!sideView"
      src="assets/icons/company.svg" />
    <div class="menu-text" [class.d-inline-block]="!sideView">Company</div>
  </li>
  <li
    [class.btn]="!sideView"
    [class.btn-link]="!sideView"
    [class.nav-link]="!sideView"
    [class.flex-end--mobile]="!sideView"
    [class.text-start]="!sideView"
    *ngIf="!isClientPortal && !isEmployeePortal"
    [ngClass]="{ active: activeTab == 'Notes' }"
    (click)="openClientNotesModal()">
    <i
      [class.d-inline-block]="!sideView"
      [class.me-3]="!sideView"
      [class.ms-3]="!sideView"
      [class.pt-3]="sideView"
      [class.pb-1]="sideView"
      class="fas fa-sticky-note fa-3x"></i>
    <div class="menu-text" [class.d-inline-block]="!sideView">Notes</div>
  </li>
  <li
    [class.btn]="!sideView"
    [class.btn-link]="!sideView"
    [class.nav-link]="!sideView"
    [class.flex-end--mobile]="!sideView"
    [class.text-start]="!sideView"
    routerLink="{{ baseUrl }}/{{ clientCode | async }}/time-off"
    *ngIf="(canShowTimeOff | async) && hasTimeOffPermission && !isEmployeePortal">
    <img
      [class.d-inline-block]="!sideView"
      [class.me-3]="!sideView"
      [class.ms-3]="!sideView"
      src="assets/icons/calendar-alt.svg"
      [ngClass]="{ active: activeTab == 'timeoff' }" />
    <div class="menu-text" [class.d-inline-block]="!sideView">Time Off</div>
  </li>
  <li
    [class.btn]="!sideView"
    [class.btn-link]="!sideView"
    [class.nav-link]="!sideView"
    [class.flex-end--mobile]="!sideView"
    [class.text-start]="!sideView"
    *ngIf="!isEmployeePortal"
    routerLinkActive="active"
    routerLink="{{ baseUrl }}/{{ clientCode | async }}/settings">
    <img
      [class.d-inline-block]="!sideView"
      [class.me-3]="!sideView"
      [class.ms-3]="!sideView"
      src="assets/icons/gear.svg" />
    <div class="menu-text" [class.d-inline-block]="!sideView">Settings</div>
  </li>

  <li
    [class.btn]="!sideView"
    [class.btn-link]="!sideView"
    [class.nav-link]="!sideView"
    [class.flex-end--mobile]="!sideView"
    [class.text-start]="!sideView"
    *ngIf="isEmployeePortal"
    routerLink="{{ baseUrl }}/{{ clientCode | async }}"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: true }">
    <img
      [class.d-inline-block]="!sideView"
      [class.me-3]="!sideView"
      [class.ms-3]="!sideView"
      src="assets/icons/home.svg" />
    <div class="menu-text" [class.d-inline-block]="!sideView">Home</div>
  </li>
  <li
    [class.btn]="!sideView"
    [class.btn-link]="!sideView"
    [class.nav-link]="!sideView"
    [class.flex-end--mobile]="!sideView"
    [class.text-start]="!sideView"
    *ngIf="isEmployeePortal"
    routerLinkActive="active"
    routerLink="{{ baseUrl }}/{{ clientCode | async }}/mypay">
    <img
      [class.d-inline-block]="!sideView"
      [class.me-3]="!sideView"
      [class.ms-3]="!sideView"
      src="assets/icons/payroll.svg"
      [ngClass]="{ active: activeTab == 'mypay' }" />
    <div class="menu-text" [class.d-inline-block]="!sideView">My Pay</div>
  </li>
  <li
    [class.btn]="!sideView"
    [class.btn-link]="!sideView"
    [class.nav-link]="!sideView"
    [class.flex-end--mobile]="!sideView"
    [class.text-start]="!sideView"
    *ngIf="isEmployeePortal"
    routerLinkActive="active"
    routerLink="{{ baseUrl }}/{{ clientCode | async }}/myforms">
    <img
      [class.d-inline-block]="!sideView"
      [class.me-3]="!sideView"
      [class.ms-3]="!sideView"
      src="assets/icons/payroll.svg"
      [ngClass]="{ active: activeTab == 'myforms' }" />
    <div class="menu-text" [class.d-inline-block]="!sideView">My Forms</div>
  </li>
  <li
    [class.btn]="!sideView"
    [class.btn-link]="!sideView"
    [class.nav-link]="!sideView"
    [class.flex-end--mobile]="!sideView"
    [class.text-start]="!sideView"
    *ngIf="isEmployeePortal && (hasSwipeclockAccess | async)"
    routerLinkActive="active"
    routerLink="{{ baseUrl }}/{{ clientCode | async }}/mytime">
    <img
      [class.d-inline-block]="!sideView"
      [class.me-3]="!sideView"
      [class.ms-3]="!sideView"
      src="assets/icons/calendar-alt.svg"
      [ngClass]="{ active: activeTab == 'mytime' }" />
    <div class="menu-text" [class.d-inline-block]="!sideView">My Time</div>
  </li>
  <li
    [class.btn]="!sideView"
    [class.btn-link]="!sideView"
    [class.nav-link]="!sideView"
    [class.flex-end--mobile]="!sideView"
    [class.text-start]="!sideView"
    *ngIf="isEmployeePortal"
    routerLinkActive="active"
    routerLink="{{ baseUrl }}/{{ clientCode | async }}/myinfo">
    <img
      [class.d-inline-block]="!sideView"
      [class.me-3]="!sideView"
      [class.ms-3]="!sideView"
      src="assets/icons/address-card.svg"
      [ngClass]="{ active: activeTab == 'myinfo' }" />
    <div class="menu-text" [class.d-inline-block]="!sideView">My Info</div>
  </li>
  <li
    [class.btn]="!sideView"
    [class.btn-link]="!sideView"
    [class.nav-link]="!sideView"
    [class.flex-end--mobile]="!sideView"
    [class.text-start]="!sideView"
    routerLink="{{ baseUrl }}/{{ clientCode | async }}/time-off"
    *ngIf="(canShowTimeOff | async) && isEmployeePortal">
    <img
      [class.d-inline-block]="!sideView"
      [class.me-3]="!sideView"
      [class.ms-3]="!sideView"
      src="assets/icons/calendar-alt.svg"
      [ngClass]="{ active: activeTab == 'timeoff' }" />
    <div class="menu-text" [class.d-inline-block]="!sideView">Time Off</div>
  </li>
  <li
    [class.btn]="!sideView"
    [class.btn-link]="!sideView"
    [class.nav-link]="!sideView"
    [class.flex-end--mobile]="!sideView"
    [class.text-start]="!sideView"
    *ngIf="isEmployeePortal"
    routerLinkActive="active"
    routerLink="{{ baseUrl }}/{{ clientCode | async }}/settings">
    <img
      [class.d-inline-block]="!sideView"
      [class.me-3]="!sideView"
      [class.ms-3]="!sideView"
      src="assets/icons/transparent-settings-cog.svg"
      [ngClass]="{ active: activeTab == 'settings' }" />
    <div class="menu-text" [class.d-inline-block]="!sideView">Settings</div>
  </li>
</ul>
